__webpack_require__.p = "https://partnership-mpos-frontend-prod.ackoassets.com/next_assets/6425c4de31a2ab1a228fe695ca436274c8c42417/_next/";